import { activityLogsApi } from "./activityLogsApi";

const onGetUserActivities = payload => async dispatch => {
    const response = await activityLogsApi.getUserActivityLogs(payload);
    return response;
};

const onGetUserActivityControllerList = () => async dispatch => {
    let response = await activityLogsApi.getUserActivityControllerList();
    return response;
};

const onGetUserActivityActionList = () => async dispatch => {
    let response = await activityLogsApi.getUserActivityActionList();
    return response;
};

export const activityLogsActions = {
    onGetUserActivities: onGetUserActivities,
    onGetUserActivityControllerList: onGetUserActivityControllerList,
    onGetUserActivityActionList: onGetUserActivityActionList,
};
